import { VerificarPermissoes } from './../model/verificarPermissoes.model';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Produtos } from '../model/produtos.model';
import { ProdutosService } from '../service/produtos.service';

@Component({
  selector: 'app-produtos',
  templateUrl: './produtos.component.html',
  styleUrls: ['./produtos.component.css']
})
export class ProdutosComponent implements OnInit {
  public paginaAtual = 1;
  produtos: Produtos[] = [];
  page = 1;
  count = 0;
  pageSize = 1;

  constructor(private service: ProdutosService, private router: Router) { }

  ngOnInit(): void {
    // this.listarProduto();
    this.listarProdutoPaginate();
  }

  parametroSolicitacao(page: number): any {
    let params: any = {};
    if (page) {
      params[`page`] = page;
    }

    return params;
  }

  listarProdutoPaginate() {
    const params = this.parametroSolicitacao(this.page);

    this.service.getAll(params).subscribe(
      resp => {
        const { last_page, data } = resp;
        this.produtos = data;
        this.count = last_page;
      }, error => {
        if (error == "401") {
          localStorage.removeItem('token')
          this.router.navigate(['/'])
        }
      }
    )
  }

  mudarPagina(event: number): void {
    this.page = event;
    this.listarProdutoPaginate();
  }

  listarProduto(): void {
    this.service.listarService().subscribe(resp => {
      this.produtos = resp
    })
  }

  finalizar(produto: Produtos): void {
    if (produto.bl_status) {
      this.service.confirmAlert(produto);
    } else {
      this.service.desativarAlert(produto);
    }
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }


}
